import { Camera } from 'lucide-react';

interface NavbarProps {
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

export default function Navbar({ currentPage = 'home', onNavigate }: NavbarProps) {
  const handleNavClick = (page: string) => {
    if (onNavigate) {
      onNavigate(page);
    }
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <button
            onClick={() => handleNavClick('home')}
            className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
          >
            <Camera className="w-8 h-8 text-blue-600" />
            <span className="text-xl font-semibold text-gray-900">PassportPhoto</span>
          </button>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => handleNavClick('home')}
              className={`text-sm font-medium transition-colors ${
                currentPage === 'home' ? 'text-blue-600' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => handleNavClick('about')}
              className={`text-sm font-medium transition-colors ${
                currentPage === 'about' ? 'text-blue-600' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              About
            </button>
            <button
              onClick={() => handleNavClick('help')}
              className={`text-sm font-medium transition-colors ${
                currentPage === 'help' ? 'text-blue-600' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Help
            </button>
            <button
              onClick={() => handleNavClick('contact')}
              className={`text-sm font-medium transition-colors ${
                currentPage === 'contact' ? 'text-blue-600' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => handleNavClick('upload')}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
